module.exports = __webpack_public_path__ + "static/img/order-pc-5.dd733645.png";